import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Modal,
//   Card,
//   Table,
//   Row,
//   Col,
//   Spinner,
//   Alert,
//   Badge,
//   Input,
//   Select,
// } from "react-bootstrap";
import { Button, Modal, Form, Input, Select, message, Space } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import { api } from "../../../Services/api";
import Tables from "../../Reuseable/Tables";
import { CALL_API } from "../../../Api";
import styled from "styled-components";
import {
  DeleteOutlined,
  ExclamationCircleFilled,
  HolderOutlined,
} from "@ant-design/icons";
import axios from "axios";
const { Option } = Select;
const { TextArea } = Input;

const severityVariant = (severity) => {
  switch ((severity || "").toLowerCase()) {
    case "high":
      return "danger";
    case "medium":
      return "warning";
    case "low":
      return "success";
    default:
      return "secondary";
  }
};

const ClientFeedback = () => {
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchClientFeedback = async () => {
    setLoading(true);
    const response = await CALL_API("/clientfeedback", "GET");
    if (response && !(response instanceof Error)) {
      setFeedbackData(response);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClientFeedback();
  }, []);

  return <TaskTable />;
};

const TaskTable = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  console.log("tasks", tasks);
  const fetchClientFeedback = async () => {
    try {
      setLoading(true);
      const responseData = await CALL_API("/clientfeedback", "GET", null);
      console.log("responseData0", responseData);
      const taskList = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.data)
          ? responseData.data
          : [];

      setTasks(taskList);
      setTasks(taskList);
      setError(null);
    } catch (err) {
      setError("Failed to load client feedback data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClientFeedback();
  }, []);

  if (loading) return <StatusMessage>Loading table data...</StatusMessage>;
  if (error)
    return <StatusMessage style={{ color: "#ff4d4f" }}>{error}</StatusMessage>;

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await CALL_API("/clientfeedback", "POST", values);

      message.success("Feedback submitted successfully!");
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {
      message.error("Failed to submit feedback. Please try again.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <p style={{ color: "white" }}>hehhhe</p> */}
      <Button
        type="primary"
        shape="circle"
        icon={<CommentOutlined />}
        size="large"
        onClick={() => setIsModalOpen(true)}
        style={{
          position: "fixed",
          bottom: 40,
          right: 40,
          zIndex: 999991000,
          width: 50,
          height: 50,
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          backgroundColor: "",
        }}
      />

      <Modal
        title="Submit Feedback / Support Ticket"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        footer={null} // Using Form buttons instead of Modal default buttons
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            severity: "High", // Default value
          }}
        >
          <Form.Item
            name="userId"
            label="User ID"
            rules={[{ required: true, message: "Please input your User ID!" }]}
          >
            <Input placeholder="Enter your User ID" />
          </Form.Item>

          <Form.Item
            name="clientName"
            label="Client Name"
            rules={[{ required: true, message: "Please input your name!" }]}
          >
            <Input placeholder="Enter client name" />
          </Form.Item>

          <Form.Item
            name="phoneNumber"
            label="Phone Number"
            rules={[
              { required: true, message: "Please input your phone number!" },
              {
                pattern: /^\d{10}$/,
                message: "Please enter a valid 10-digit phone number!",
              },
            ]}
          >
            <Input placeholder="Enter 10-digit phone number" maxLength={10} />
          </Form.Item>

          <Form.Item
            name="mailId"
            label="Email Address"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email address!" },
            ]}
          >
            <Input placeholder="Enter email address" />
          </Form.Item>

          <Form.Item
            name="severity"
            label="Severity"
            rules={[
              { required: true, message: "Please select severity level!" },
            ]}
          >
            <Select placeholder="Select severity">
              <Option value="Low">Low</Option>
              <Option value="Medium">Medium</Option>
              <Option value="High">High</Option>
              <Option value="Critical">Critical</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please enter a description!" }]}
          >
            <Input placeholder="e.g., Unable to create task" />
          </Form.Item>

          <Form.Item
            name="information"
            label="Additional Information"
            rules={[
              { required: true, message: "Please provide error details!" },
            ]}
          >
            <TextArea rows={3} placeholder="e.g., Task save failed" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Space>
              <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit Ticket
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <Th style={{ width: "40px" }}>
                <Checkbox />
              </Th>
              <Th>
                Feedback ID <span>↓</span>
              </Th>
              <Th>Client Name</Th>
              <Th>Email ID</Th>
              <Th>Phone Number</Th>
              <Th>Information</Th>
              <Th>Description</Th>
              <Th>
                Severity <span>↓</span>
              </Th>
              <Th>
                Created At <span>↓</span>
              </Th>
              <Th style={{ textAlign: "center" }}>Actions</Th>
            </tr>
          </thead>
          <tbody>
            {tasks.length === 0 ? (
              <Tr>
                <Td
                  colSpan={10}
                  style={{ textAlign: "center", color: "#8c8c8c" }}
                >
                  No feedback data available.
                </Td>
              </Tr>
            ) : (
              tasks.map((row) => (
                <Tr key={row.feedbackId || row.userId}>
                  <Td>
                    <DragHandle />
                    <Checkbox />
                  </Td>
                  <Td style={{ fontWeight: 500 }}>{row.feedbackId || "-"}</Td>
                  <Td>{row.clientName || "-"}</Td>
                  <Td style={{ color: "#a0a0a0" }}>{row.mailId || "-"}</Td>
                  <Td>{row.phoneNumber || "-"}</Td>
                  <Td>{row.information || "-"}</Td>
                  <Td>{row.description || "-"}</Td>
                  <Td>
                    {row.severity ? (
                      <SignalBadge type={row.severity.toUpperCase()}>
                        <ExclamationCircleFilled /> {row.severity.toUpperCase()}
                      </SignalBadge>
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>
                    {row.createdAt
                      ? new Date(row.createdAt).toLocaleString()
                      : "-"}
                  </Td>
                  <Td style={{ textAlign: "center" }}>
                    <ActionIcon />
                  </Td>
                </Tr>
              ))
            )}
          </tbody>
        </StyledTable>
      </TableContainer>
    </>
  );
};
const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: #2a2a2a;
  border-radius: 10px;
  padding: 16px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
  color: #e0e0e0;
  text-align: left;
`;

const Th = styled.th`
  background-color: #333333;
  color: #ffffff;
  padding: 14px 12px;
  font-weight: 600;
  border-bottom: 1px solid #444444;
  white-space: nowrap;

  span {
    font-size: 11px;
    margin-left: 4px;
    color: #8c8c8c;
  }
`;

const Tr = styled.tr`
  border-bottom: 1px solid #3a3a3a;
  background-color: #2a2a2a;

  &:hover {
    background-color: #333333;
  }
`;

const Td = styled.td`
  padding: 12px;
  vertical-align: middle;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  cursor: pointer;
  accent-color: #1890ff;
  width: 14px;
  height: 14px;
`;

const DragHandle = styled(HolderOutlined)`
  color: #555555;
  cursor: grab;
  margin-right: 8px;
  font-size: 14px;
  vertical-align: middle;
`;

const ActionIcon = styled(DeleteOutlined)`
  color: #4c9aff;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: #ff4d4f;
  }
`;

const SignalBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: ${(props) =>
    props.type === "RED"
      ? "rgba(255, 77, 79, 0.1)"
      : "rgba(255, 197, 61, 0.1)"};
  color: ${(props) => (props.type === "RED" ? "#ff4d4f" : "#ffc53d")};
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
`;

const StatusMessage = styled.div`
  color: #a0a0a0;
  text-align: center;
  padding: 20px;
  font-family: sans-serif;
`;
export default ClientFeedback;
